import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { nanoid } from 'nanoid'

import { useGetPulseSurveyDetail } from 'hooks/pulseSurveys/useGetPulseSurveyDetail'
import { usePulseSurveys } from 'hooks/usePulseSurveys'
import { PulseSurveysError } from '../Error'

import { ACTION_ALLOWED_STATUTES } from './../pulseSurvey.helpers'
import { FormDefaultData } from './FormBuilder/formBuilder.types'
import { FormBuilder } from './FormBuilder'
import { Preview } from './Preview'
import * as S from './create.styles'

export const Create = () => {
    const params = useParams<{ id: string }>()

    const surveyUUID = params.id

    const { activePulseSurvey, onChangeActivePulseSurvey } = usePulseSurveys()

    const { data, isLoading, isError } = useGetPulseSurveyDetail({ surveyUUID })

    useEffect(() => {
        if (data && !activePulseSurvey?.uuid) {
            onChangeActivePulseSurvey(data)
        }
    }, [data, activePulseSurvey?.uuid, onChangeActivePulseSurvey])

    if (isError) {
        return <PulseSurveysError />
    }

    if (isLoading) {
        return (
            <S.CreateWrapper>
                {new Array(24).fill('').map((_, index) => (
                    <S.FormSkeleton key={index} variant="rect" width={800} height={56} />
                ))}
            </S.CreateWrapper>
        )
    }

    if (!data) {
        return null
    }

    const defaultData: FormDefaultData = {
        title: data.title,
        description: data.description,
        questions: data.config_data.questions.map((question) => ({
            id: nanoid(),
            value: question.title,
            type: question.question_type,
            required: question.required,
            options: question.options?.map((option) => ({
                id: nanoid(),
                value: option,
            })),
            hasOther: question.has_other,
            ratingType: question.display_sub_type,
            ratingWeight: question.weight,
        })),
    }

    if (!ACTION_ALLOWED_STATUTES.update.includes(data.status)) {
        return (
            <S.CreateWrapper>
                <Preview surveyUUID={surveyUUID}>
                    <FormBuilder key={surveyUUID} defaultData={defaultData} surveyUUID={surveyUUID} previewMode />
                </Preview>
            </S.CreateWrapper>
        )
    }

    return (
        <S.CreateWrapper>
            <FormBuilder key={surveyUUID} defaultData={defaultData} surveyUUID={surveyUUID} />
        </S.CreateWrapper>
    )
}
